/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AddMissingLogToPointLogReqBodyDto } from '../../src/model';
// @ts-ignore
import type { GetAutoSavePointBadRequestDto } from '../../src/model';
// @ts-ignore
import type { GetAutoSavePointInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetAutoSavePointOkDto } from '../../src/model';
// @ts-ignore
import type { GetAutoSavePointReqQueryDto } from '../../src/model';
// @ts-ignore
import type { GetEarnedPointRankingInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetEarnedPointRankingOkDto } from '../../src/model';
// @ts-ignore
import type { GetEarnedPointReqQueryDto } from '../../src/model';
// @ts-ignore
import type { GetEarnedPointsBadRequestDto } from '../../src/model';
// @ts-ignore
import type { GetEarnedPointsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetEarnedPointsOkDto } from '../../src/model';
// @ts-ignore
import type { GetLastMonthPointRankingInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetLastMonthPointRankingOkDto } from '../../src/model';
// @ts-ignore
import type { GetLastWeekPointRankingInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetLastWeekPointRankingOkDto } from '../../src/model';
// @ts-ignore
import type { GetPointCountInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetPointCountOkDto } from '../../src/model';
// @ts-ignore
import type { GetPointTrendInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetPointTrendOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { SyncExchangeablePointToTotalPointReqBodyDto } from '../../src/model';
// @ts-ignore
import type { SyncTotalPointFromLatestPointLogReqBodyDto } from '../../src/model';
/**
 * PointApi - axios parameter creator
 * @export
 */
export const PointApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [백엔드 전용] 누락된 포인트 로그 테이블의 row 추가
         * @param {AddMissingLogToPointLogReqBodyDto} addMissingLogToPointLogReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerAddMissingLogToPointLog: async (addMissingLogToPointLogReqBodyDto: AddMissingLogToPointLogReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addMissingLogToPointLogReqBodyDto' is not null or undefined
            assertParamExists('pointControllerAddMissingLogToPointLog', 'addMissingLogToPointLogReqBodyDto', addMissingLogToPointLogReqBodyDto)
            const localVarPath = `/point/log/missing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMissingLogToPointLogReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 자동 적립된 포인트 내역 총합 조회
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {PointControllerGetAutoSavePointPointTypeEnum} [pointType] 포인트 카테고리 id 목록
         * @param {GetAutoSavePointReqQueryDto} [getAutoSavePointReqQueryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetAutoSavePoint: async (startDate?: string, endDate?: string, pointType?: PointControllerGetAutoSavePointPointTypeEnum, getAutoSavePointReqQueryDto?: GetAutoSavePointReqQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/point/auto-save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (pointType !== undefined) {
                localVarQueryParameter['pointType'] = pointType;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAutoSavePointReqQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 적립한 포인트 내역 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {Array<PointControllerGetEarnedPointPointCategoryIdsEnum>} [pointCategoryIds] 포인트 카테고리 id 목록
         * @param {GetEarnedPointReqQueryDto} [getEarnedPointReqQueryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetEarnedPoint: async (page?: number, limit?: number, startDate?: string, endDate?: string, pointCategoryIds?: Array<PointControllerGetEarnedPointPointCategoryIdsEnum>, getEarnedPointReqQueryDto?: GetEarnedPointReqQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/point/earned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (pointCategoryIds) {
                localVarQueryParameter['pointCategoryIds'] = pointCategoryIds;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getEarnedPointReqQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 누적 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetEarnedPointRanking: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/point/ranking/earned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 지난달 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetLastMonthPointRanking: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/point/ranking/last-month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 지난주 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetLastWeekPointRanking: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/point/ranking/last-week`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 오늘 모은 뷰잉하기 포인트, 오늘 모은 자동적립 포인트, 오늘 모은 뷰업 플러스 포인트, 전체 포인트, 환급 가능 포인트 개수 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetPointCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/point/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 포인트 추이 조회
         * @param {number} year 년도
         * @param {Array<PointControllerGetPointTrendPointCategoriesEnum>} pointCategories 포인트 카테고리 enum 목록
         * @param {number} [month] 월
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetPointTrend: async (year: number, pointCategories: Array<PointControllerGetPointTrendPointCategoriesEnum>, month?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('pointControllerGetPointTrend', 'year', year)
            // verify required parameter 'pointCategories' is not null or undefined
            assertParamExists('pointControllerGetPointTrend', 'pointCategories', pointCategories)
            const localVarPath = `/point/trend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (pointCategories) {
                localVarQueryParameter['pointCategories'] = pointCategories;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerPpapppapppappPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/point/ppapppapppapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [백엔드 전용] 유저의 환급가능액을 잔액과 동기화
         * @param {SyncExchangeablePointToTotalPointReqBodyDto} syncExchangeablePointToTotalPointReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerSyncExchangeablePointToBalance: async (syncExchangeablePointToTotalPointReqBodyDto: SyncExchangeablePointToTotalPointReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncExchangeablePointToTotalPointReqBodyDto' is not null or undefined
            assertParamExists('pointControllerSyncExchangeablePointToBalance', 'syncExchangeablePointToTotalPointReqBodyDto', syncExchangeablePointToTotalPointReqBodyDto)
            const localVarPath = `/point/exchangeable/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncExchangeablePointToTotalPointReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [백엔드 전용] 포인트 로그 동기화
         * @param {AddMissingLogToPointLogReqBodyDto} addMissingLogToPointLogReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerSyncPointLog: async (addMissingLogToPointLogReqBodyDto: AddMissingLogToPointLogReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addMissingLogToPointLogReqBodyDto' is not null or undefined
            assertParamExists('pointControllerSyncPointLog', 'addMissingLogToPointLogReqBodyDto', addMissingLogToPointLogReqBodyDto)
            const localVarPath = `/point/log/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMissingLogToPointLogReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [백엔드 전용] 유저의 잔액을 포인트 로그의 제일 마지막 로그와 동기화
         * @param {SyncTotalPointFromLatestPointLogReqBodyDto} syncTotalPointFromLatestPointLogReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerSyncTotalPoint: async (syncTotalPointFromLatestPointLogReqBodyDto: SyncTotalPointFromLatestPointLogReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncTotalPointFromLatestPointLogReqBodyDto' is not null or undefined
            assertParamExists('pointControllerSyncTotalPoint', 'syncTotalPointFromLatestPointLogReqBodyDto', syncTotalPointFromLatestPointLogReqBodyDto)
            const localVarPath = `/point/totalPoint/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncTotalPointFromLatestPointLogReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointApi - functional programming interface
 * @export
 */
export const PointApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [백엔드 전용] 누락된 포인트 로그 테이블의 row 추가
         * @param {AddMissingLogToPointLogReqBodyDto} addMissingLogToPointLogReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerAddMissingLogToPointLog(addMissingLogToPointLogReqBodyDto: AddMissingLogToPointLogReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerAddMissingLogToPointLog(addMissingLogToPointLogReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerAddMissingLogToPointLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 자동 적립된 포인트 내역 총합 조회
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {PointControllerGetAutoSavePointPointTypeEnum} [pointType] 포인트 카테고리 id 목록
         * @param {GetAutoSavePointReqQueryDto} [getAutoSavePointReqQueryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerGetAutoSavePoint(startDate?: string, endDate?: string, pointType?: PointControllerGetAutoSavePointPointTypeEnum, getAutoSavePointReqQueryDto?: GetAutoSavePointReqQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAutoSavePointOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerGetAutoSavePoint(startDate, endDate, pointType, getAutoSavePointReqQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerGetAutoSavePoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 적립한 포인트 내역 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {Array<PointControllerGetEarnedPointPointCategoryIdsEnum>} [pointCategoryIds] 포인트 카테고리 id 목록
         * @param {GetEarnedPointReqQueryDto} [getEarnedPointReqQueryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerGetEarnedPoint(page?: number, limit?: number, startDate?: string, endDate?: string, pointCategoryIds?: Array<PointControllerGetEarnedPointPointCategoryIdsEnum>, getEarnedPointReqQueryDto?: GetEarnedPointReqQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEarnedPointsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerGetEarnedPoint(page, limit, startDate, endDate, pointCategoryIds, getEarnedPointReqQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerGetEarnedPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 누적 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerGetEarnedPointRanking(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEarnedPointRankingOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerGetEarnedPointRanking(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerGetEarnedPointRanking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 지난달 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerGetLastMonthPointRanking(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLastMonthPointRankingOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerGetLastMonthPointRanking(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerGetLastMonthPointRanking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 지난주 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerGetLastWeekPointRanking(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLastWeekPointRankingOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerGetLastWeekPointRanking(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerGetLastWeekPointRanking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 오늘 모은 뷰잉하기 포인트, 오늘 모은 자동적립 포인트, 오늘 모은 뷰업 플러스 포인트, 전체 포인트, 환급 가능 포인트 개수 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerGetPointCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPointCountOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerGetPointCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerGetPointCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 포인트 추이 조회
         * @param {number} year 년도
         * @param {Array<PointControllerGetPointTrendPointCategoriesEnum>} pointCategories 포인트 카테고리 enum 목록
         * @param {number} [month] 월
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerGetPointTrend(year: number, pointCategories: Array<PointControllerGetPointTrendPointCategoriesEnum>, month?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPointTrendOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerGetPointTrend(year, pointCategories, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerGetPointTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerPpapppapppappPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerPpapppapppappPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerPpapppapppappPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [백엔드 전용] 유저의 환급가능액을 잔액과 동기화
         * @param {SyncExchangeablePointToTotalPointReqBodyDto} syncExchangeablePointToTotalPointReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerSyncExchangeablePointToBalance(syncExchangeablePointToTotalPointReqBodyDto: SyncExchangeablePointToTotalPointReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerSyncExchangeablePointToBalance(syncExchangeablePointToTotalPointReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerSyncExchangeablePointToBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [백엔드 전용] 포인트 로그 동기화
         * @param {AddMissingLogToPointLogReqBodyDto} addMissingLogToPointLogReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerSyncPointLog(addMissingLogToPointLogReqBodyDto: AddMissingLogToPointLogReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerSyncPointLog(addMissingLogToPointLogReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerSyncPointLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [백엔드 전용] 유저의 잔액을 포인트 로그의 제일 마지막 로그와 동기화
         * @param {SyncTotalPointFromLatestPointLogReqBodyDto} syncTotalPointFromLatestPointLogReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointControllerSyncTotalPoint(syncTotalPointFromLatestPointLogReqBodyDto: SyncTotalPointFromLatestPointLogReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointControllerSyncTotalPoint(syncTotalPointFromLatestPointLogReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointApi.pointControllerSyncTotalPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PointApi - factory interface
 * @export
 */
export const PointApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointApiFp(configuration)
    return {
        /**
         * 
         * @summary [백엔드 전용] 누락된 포인트 로그 테이블의 row 추가
         * @param {PointApiPointControllerAddMissingLogToPointLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerAddMissingLogToPointLog(requestParameters: PointApiPointControllerAddMissingLogToPointLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pointControllerAddMissingLogToPointLog(requestParameters.addMissingLogToPointLogReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 자동 적립된 포인트 내역 총합 조회
         * @param {PointApiPointControllerGetAutoSavePointRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetAutoSavePoint(requestParameters: PointApiPointControllerGetAutoSavePointRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAutoSavePointOkDto> {
            return localVarFp.pointControllerGetAutoSavePoint(requestParameters.startDate, requestParameters.endDate, requestParameters.pointType, requestParameters.getAutoSavePointReqQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 적립한 포인트 내역 조회
         * @param {PointApiPointControllerGetEarnedPointRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetEarnedPoint(requestParameters: PointApiPointControllerGetEarnedPointRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetEarnedPointsOkDto> {
            return localVarFp.pointControllerGetEarnedPoint(requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, requestParameters.pointCategoryIds, requestParameters.getEarnedPointReqQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 누적 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetEarnedPointRanking(options?: RawAxiosRequestConfig): AxiosPromise<GetEarnedPointRankingOkDto> {
            return localVarFp.pointControllerGetEarnedPointRanking(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 지난달 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetLastMonthPointRanking(options?: RawAxiosRequestConfig): AxiosPromise<GetLastMonthPointRankingOkDto> {
            return localVarFp.pointControllerGetLastMonthPointRanking(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 지난주 포인트 랭킹 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetLastWeekPointRanking(options?: RawAxiosRequestConfig): AxiosPromise<GetLastWeekPointRankingOkDto> {
            return localVarFp.pointControllerGetLastWeekPointRanking(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 오늘 모은 뷰잉하기 포인트, 오늘 모은 자동적립 포인트, 오늘 모은 뷰업 플러스 포인트, 전체 포인트, 환급 가능 포인트 개수 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetPointCount(options?: RawAxiosRequestConfig): AxiosPromise<GetPointCountOkDto> {
            return localVarFp.pointControllerGetPointCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 포인트 추이 조회
         * @param {PointApiPointControllerGetPointTrendRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerGetPointTrend(requestParameters: PointApiPointControllerGetPointTrendRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPointTrendOkDto> {
            return localVarFp.pointControllerGetPointTrend(requestParameters.year, requestParameters.pointCategories, requestParameters.month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerPpapppapppappPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pointControllerPpapppapppappPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [백엔드 전용] 유저의 환급가능액을 잔액과 동기화
         * @param {PointApiPointControllerSyncExchangeablePointToBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerSyncExchangeablePointToBalance(requestParameters: PointApiPointControllerSyncExchangeablePointToBalanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pointControllerSyncExchangeablePointToBalance(requestParameters.syncExchangeablePointToTotalPointReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [백엔드 전용] 포인트 로그 동기화
         * @param {PointApiPointControllerSyncPointLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerSyncPointLog(requestParameters: PointApiPointControllerSyncPointLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pointControllerSyncPointLog(requestParameters.addMissingLogToPointLogReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [백엔드 전용] 유저의 잔액을 포인트 로그의 제일 마지막 로그와 동기화
         * @param {PointApiPointControllerSyncTotalPointRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointControllerSyncTotalPoint(requestParameters: PointApiPointControllerSyncTotalPointRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pointControllerSyncTotalPoint(requestParameters.syncTotalPointFromLatestPointLogReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for pointControllerAddMissingLogToPointLog operation in PointApi.
 * @export
 * @interface PointApiPointControllerAddMissingLogToPointLogRequest
 */
export interface PointApiPointControllerAddMissingLogToPointLogRequest {
    /**
     * 
     * @type {AddMissingLogToPointLogReqBodyDto}
     * @memberof PointApiPointControllerAddMissingLogToPointLog
     */
    readonly addMissingLogToPointLogReqBodyDto: AddMissingLogToPointLogReqBodyDto
}

/**
 * Request parameters for pointControllerGetAutoSavePoint operation in PointApi.
 * @export
 * @interface PointApiPointControllerGetAutoSavePointRequest
 */
export interface PointApiPointControllerGetAutoSavePointRequest {
    /**
     * 시작 날짜
     * @type {string}
     * @memberof PointApiPointControllerGetAutoSavePoint
     */
    readonly startDate?: string

    /**
     * 끝 날짜
     * @type {string}
     * @memberof PointApiPointControllerGetAutoSavePoint
     */
    readonly endDate?: string

    /**
     * 포인트 카테고리 id 목록
     * @type {'like' | 'follow' | 'comment' | 'pagelike' | 'subscribe' | 'post' | 'install' | 'rating' | 'join' | 'friend' | 'event' | 'blog' | 'scrap' | 'bookmark' | 'notification' | 'campaign_report' | 'user_report' | 'admin' | 'badge' | 'sns_account_delete' | 'exchange'}
     * @memberof PointApiPointControllerGetAutoSavePoint
     */
    readonly pointType?: PointControllerGetAutoSavePointPointTypeEnum

    /**
     * 
     * @type {GetAutoSavePointReqQueryDto}
     * @memberof PointApiPointControllerGetAutoSavePoint
     */
    readonly getAutoSavePointReqQueryDto?: GetAutoSavePointReqQueryDto
}

/**
 * Request parameters for pointControllerGetEarnedPoint operation in PointApi.
 * @export
 * @interface PointApiPointControllerGetEarnedPointRequest
 */
export interface PointApiPointControllerGetEarnedPointRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof PointApiPointControllerGetEarnedPoint
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof PointApiPointControllerGetEarnedPoint
     */
    readonly limit?: number

    /**
     * 시작 날짜
     * @type {string}
     * @memberof PointApiPointControllerGetEarnedPoint
     */
    readonly startDate?: string

    /**
     * 끝 날짜
     * @type {string}
     * @memberof PointApiPointControllerGetEarnedPoint
     */
    readonly endDate?: string

    /**
     * 포인트 카테고리 id 목록
     * @type {Array<'click' | 'install' | 'post' | 'etc' | 'auto' | 'plus' | 'supporters' | 'guardian' | 'admin' | 'system'>}
     * @memberof PointApiPointControllerGetEarnedPoint
     */
    readonly pointCategoryIds?: Array<PointControllerGetEarnedPointPointCategoryIdsEnum>

    /**
     * 
     * @type {GetEarnedPointReqQueryDto}
     * @memberof PointApiPointControllerGetEarnedPoint
     */
    readonly getEarnedPointReqQueryDto?: GetEarnedPointReqQueryDto
}

/**
 * Request parameters for pointControllerGetPointTrend operation in PointApi.
 * @export
 * @interface PointApiPointControllerGetPointTrendRequest
 */
export interface PointApiPointControllerGetPointTrendRequest {
    /**
     * 년도
     * @type {number}
     * @memberof PointApiPointControllerGetPointTrend
     */
    readonly year: number

    /**
     * 포인트 카테고리 enum 목록
     * @type {Array<'click' | 'install' | 'post' | 'etc' | 'auto' | 'plus' | 'supporters' | 'guardian' | 'admin' | 'system'>}
     * @memberof PointApiPointControllerGetPointTrend
     */
    readonly pointCategories: Array<PointControllerGetPointTrendPointCategoriesEnum>

    /**
     * 월
     * @type {number}
     * @memberof PointApiPointControllerGetPointTrend
     */
    readonly month?: number
}

/**
 * Request parameters for pointControllerSyncExchangeablePointToBalance operation in PointApi.
 * @export
 * @interface PointApiPointControllerSyncExchangeablePointToBalanceRequest
 */
export interface PointApiPointControllerSyncExchangeablePointToBalanceRequest {
    /**
     * 
     * @type {SyncExchangeablePointToTotalPointReqBodyDto}
     * @memberof PointApiPointControllerSyncExchangeablePointToBalance
     */
    readonly syncExchangeablePointToTotalPointReqBodyDto: SyncExchangeablePointToTotalPointReqBodyDto
}

/**
 * Request parameters for pointControllerSyncPointLog operation in PointApi.
 * @export
 * @interface PointApiPointControllerSyncPointLogRequest
 */
export interface PointApiPointControllerSyncPointLogRequest {
    /**
     * 
     * @type {AddMissingLogToPointLogReqBodyDto}
     * @memberof PointApiPointControllerSyncPointLog
     */
    readonly addMissingLogToPointLogReqBodyDto: AddMissingLogToPointLogReqBodyDto
}

/**
 * Request parameters for pointControllerSyncTotalPoint operation in PointApi.
 * @export
 * @interface PointApiPointControllerSyncTotalPointRequest
 */
export interface PointApiPointControllerSyncTotalPointRequest {
    /**
     * 
     * @type {SyncTotalPointFromLatestPointLogReqBodyDto}
     * @memberof PointApiPointControllerSyncTotalPoint
     */
    readonly syncTotalPointFromLatestPointLogReqBodyDto: SyncTotalPointFromLatestPointLogReqBodyDto
}

/**
 * PointApi - object-oriented interface
 * @export
 * @class PointApi
 * @extends {BaseAPI}
 */
export class PointApi extends BaseAPI {
    /**
     * 
     * @summary [백엔드 전용] 누락된 포인트 로그 테이블의 row 추가
     * @param {PointApiPointControllerAddMissingLogToPointLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerAddMissingLogToPointLog(requestParameters: PointApiPointControllerAddMissingLogToPointLogRequest, options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerAddMissingLogToPointLog(requestParameters.addMissingLogToPointLogReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 자동 적립된 포인트 내역 총합 조회
     * @param {PointApiPointControllerGetAutoSavePointRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerGetAutoSavePoint(requestParameters: PointApiPointControllerGetAutoSavePointRequest = {}, options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerGetAutoSavePoint(requestParameters.startDate, requestParameters.endDate, requestParameters.pointType, requestParameters.getAutoSavePointReqQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 적립한 포인트 내역 조회
     * @param {PointApiPointControllerGetEarnedPointRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerGetEarnedPoint(requestParameters: PointApiPointControllerGetEarnedPointRequest = {}, options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerGetEarnedPoint(requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, requestParameters.pointCategoryIds, requestParameters.getEarnedPointReqQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 누적 포인트 랭킹 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerGetEarnedPointRanking(options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerGetEarnedPointRanking(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 지난달 포인트 랭킹 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerGetLastMonthPointRanking(options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerGetLastMonthPointRanking(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 지난주 포인트 랭킹 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerGetLastWeekPointRanking(options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerGetLastWeekPointRanking(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 오늘 모은 뷰잉하기 포인트, 오늘 모은 자동적립 포인트, 오늘 모은 뷰업 플러스 포인트, 전체 포인트, 환급 가능 포인트 개수 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerGetPointCount(options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerGetPointCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 포인트 추이 조회
     * @param {PointApiPointControllerGetPointTrendRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerGetPointTrend(requestParameters: PointApiPointControllerGetPointTrendRequest, options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerGetPointTrend(requestParameters.year, requestParameters.pointCategories, requestParameters.month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerPpapppapppappPost(options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerPpapppapppappPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [백엔드 전용] 유저의 환급가능액을 잔액과 동기화
     * @param {PointApiPointControllerSyncExchangeablePointToBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerSyncExchangeablePointToBalance(requestParameters: PointApiPointControllerSyncExchangeablePointToBalanceRequest, options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerSyncExchangeablePointToBalance(requestParameters.syncExchangeablePointToTotalPointReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [백엔드 전용] 포인트 로그 동기화
     * @param {PointApiPointControllerSyncPointLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerSyncPointLog(requestParameters: PointApiPointControllerSyncPointLogRequest, options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerSyncPointLog(requestParameters.addMissingLogToPointLogReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [백엔드 전용] 유저의 잔액을 포인트 로그의 제일 마지막 로그와 동기화
     * @param {PointApiPointControllerSyncTotalPointRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointApi
     */
    public pointControllerSyncTotalPoint(requestParameters: PointApiPointControllerSyncTotalPointRequest, options?: RawAxiosRequestConfig) {
        return PointApiFp(this.configuration).pointControllerSyncTotalPoint(requestParameters.syncTotalPointFromLatestPointLogReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PointControllerGetAutoSavePointPointTypeEnum = {
    Like: 'like',
    Follow: 'follow',
    Comment: 'comment',
    Pagelike: 'pagelike',
    Subscribe: 'subscribe',
    Post: 'post',
    Install: 'install',
    Rating: 'rating',
    Join: 'join',
    Friend: 'friend',
    Event: 'event',
    Blog: 'blog',
    Scrap: 'scrap',
    Bookmark: 'bookmark',
    Notification: 'notification',
    CampaignReport: 'campaign_report',
    UserReport: 'user_report',
    Admin: 'admin',
    Badge: 'badge',
    SnsAccountDelete: 'sns_account_delete',
    Exchange: 'exchange'
} as const;
export type PointControllerGetAutoSavePointPointTypeEnum = typeof PointControllerGetAutoSavePointPointTypeEnum[keyof typeof PointControllerGetAutoSavePointPointTypeEnum];
/**
 * @export
 */
export const PointControllerGetEarnedPointPointCategoryIdsEnum = {
    Click: 'click',
    Install: 'install',
    Post: 'post',
    Etc: 'etc',
    Auto: 'auto',
    Plus: 'plus',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Admin: 'admin',
    System: 'system'
} as const;
export type PointControllerGetEarnedPointPointCategoryIdsEnum = typeof PointControllerGetEarnedPointPointCategoryIdsEnum[keyof typeof PointControllerGetEarnedPointPointCategoryIdsEnum];
/**
 * @export
 */
export const PointControllerGetPointTrendPointCategoriesEnum = {
    Click: 'click',
    Install: 'install',
    Post: 'post',
    Etc: 'etc',
    Auto: 'auto',
    Plus: 'plus',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Admin: 'admin',
    System: 'system'
} as const;
export type PointControllerGetPointTrendPointCategoriesEnum = typeof PointControllerGetPointTrendPointCategoriesEnum[keyof typeof PointControllerGetPointTrendPointCategoriesEnum];
